import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import "../../../assets/css/steps.css";
import FormBuilder from "../../Generics/FormBuilder";

const Step_1_Delegation = ({
  delegation,
  solicitation,
  setDocBuilder,
  goToStep,
  handleNextStep,
  setInternalStep,
  setErrorPopup,
}) => {
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <Grid container>
      <Grid item xs={12} className="container-steps">
        <Typography className="title-steps">
          Compila i campi guidati (parte {currentStep} di 3)
        </Typography>
        <Typography className="text-steps" sx={{ mt: 1, mb: 2 }}>
          Inserisci le informazioni richieste per generare istantaneamente la
          tua delega.
        </Typography>

        <Grid
          item
          container
          xs={12}
          md={12}
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} md={8} style={{ marginBottom: "20px" }}>
            <FormBuilder
              goToStep={goToStep}
              setDocBuilder={setDocBuilder}
              delegation={delegation}
              formId={
                delegation.personType === "NATURAL"
                  ? solicitation.docBuilderNaturalPersonId
                  : delegation.personType === "JURIDICAL"
                    ? solicitation.docBuilderLegalPersonId
                    : null
              }
              handleNextStep={handleNextStep}
              formDataId={delegation.docBuilderSubmissionId}
              setCurrentStep={setCurrentStep}
              currentStep={currentStep}
              setErrorPopup={setErrorPopup}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Step_1_Delegation;
